import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminTopListEdit from "@/pages/admin/AdminTopListEdit";

export const Route = createFileRoute("/admin/top-lists/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminTopListEdit />
    </ProtectedRoute>
  ),
});
